<template>
<div class="container" style="max-height: 500px; overflow: auto;">
    <h5>{{userFullName}}</h5>
    <div class="mb-1">
        <div>Employers Assigned: {{totalEmployerCount}}</div>
    </div>
    <div class="">
        <a @click.prevent="closeModal({ userId: userId })" href="#">Workflows Pending: {{totalWorkflowCount}}</a>
    </div>
    <div class="flex-row mt-4" style="justify-content: center">
        <div>
            <table class="table table-sm table-hover">
                <thead>
                    <th>At Action Item</th>
                    <th># Workflows</th>
                </thead>
                <tbody>
                    <tr v-for="stat in stats" :key="stat.key">
                        <td>
                            <a @click.prevent="closeModal(stat.filter)" href="#">{{formatStatLabel(stat.key)}}</a>
                        </td>
                        <td>
                            <a @click.prevent="closeModal(stat.filter)" href="#">{{stat.value}}</a>
                        </td>
                    </tr> 
                </tbody>
            </table>
        </div>
        <div>
            <table class="table table-sm table-hover ml-4">
                <thead>
                    <th>Last Update</th>
                    <th># Workflows</th>
                </thead>
                <tbody>
                    <tr v-for="stat in dateStats" :key="stat.key">
                        <td>
                            <a @click.prevent="closeModal(stat.filter)" href="#">{{stat.key}}</a>
                        </td>
                        <td>
                            <a @click.prevent="closeModal(stat.filter)" href="#">{{stat.value}}</a>
                        </td>
                    </tr> 
                </tbody>
            </table>
        </div>
    </div>
</div>    
</template>

<script>

export default {
    props: ["userId"],
    inject:["closeModal"],
    created() {
         this.load();
    },
    data() {
        return {
            buttons: "Close",
            workflowTypes: [],
            userFullName: "",
            title: "Workflows",
            stats: [],
            dateStats: [],
            totalEmployerCount: 0,
            totalWorkflowCount: 0
        }
    },
    methods: {

        formatStatLabel(label) {
            return label.replace("ewf-", "");
        },
        async load() {
             var users = await romeApi.get("/workflow/user/stats?specialistType=cam&userId=" + this.userId);
             var user = users[0];
             this.userFullName = user.firstName + " " + user.lastName;
             this.totalEmployerCount = user.totalEmployerCount;
             this.totalWorkflowCount = user.totalWorkflowCount;
             _.keys(user.countPerActionItemType).forEach(at => {
                 this.stats.push({
                     key: at,
                     value: user.countPerActionItemType[at],
                     filter: { userId: this.userId, actionItemType: at }
                 });
             });
            var daysPerBucket = 5;
            var dateBuckets = 20;
            for(var i = 0; i <= dateBuckets; i++) {
                var dateRangeTitle = `${i * daysPerBucket}-${(i+1) * daysPerBucket} days ago`;
                if (i == dateBuckets) dateRangeTitle = "Oldest";
                var endDate = moment().clone().add(-daysPerBucket * i, "days").endOf("day");
                var startDate = endDate.clone().add(-daysPerBucket+1, "days").startOf("day");
                if (i == dateBuckets) startDate = moment('2000-1-1');
                var dates = _(user.countPerUpdatedDate).keys().orderBy(date => moment(date).unix()).value();
                var countPerDateBucket = _(dates)
                                            .filter(d => moment(d).isSameOrAfter(startDate) 
                                                    && moment(d).isSameOrBefore(endDate))
                                            .sumBy(d => user.countPerUpdatedDate[d]);
                if (countPerDateBucket) {
                    this.dateStats.push({
                        key: dateRangeTitle,
                        value: countPerDateBucket,
                        filter: { userId: this.userId, updatedStartDate: formatters.date(startDate), updatedEndDate: formatters.date(endDate) }
                    });                
                }
            }
        },
        async save() {
            return _.clone(this.data);
        },
    },
    validations() {
        return {
            data: { }
    }
}
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/workflow/UserWorkflowStatsModal.vue